import { render, staticRenderFns } from "./share-dashboard-or-chart-panel.vue?vue&type=template&id=1b772386"
import script from "./share-dashboard-or-chart-panel.vue?vue&type=script&lang=ts"
export * from "./share-dashboard-or-chart-panel.vue?vue&type=script&lang=ts"
import style0 from "./share-dashboard-or-chart-panel.vue?vue&type=style&index=0&id=1b772386&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports